module.exports = __webpack_public_path__ + "img/leju_notice.4f64ae29.jpg";